import React, { useState } from 'react';
import { Input, Button, Select } from '../styles/TableStyles';

// Group (PackTypes.Type) picker. Lists existing groups and an italic "＋ Add group…"
// sentinel pinned to the bottom; selecting it swaps the control to a text field + ＋
// button so a new group name can be created inline. Groups are derived from existing
// PackType rows, so a freshly typed name persists once the row is saved.
const ADD_SENTINEL = '__ADD_GROUP__';

const GroupSelect = ({ value, groups = [], onChange, ariaLabel = 'Group' }) => {
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState('');

  // Always keep the current value selectable, even before it lands in the derived list.
  const options = Array.from(new Set([...(value ? [value] : []), ...groups])).filter(Boolean);

  if (adding) {
    const commit = () => {
      const name = draft.trim();
      if (!name) return;
      onChange(name);
      setDraft('');
      setAdding(false);
    };
    return (
      <div style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
        <Input
          type="text"
          autoFocus
          aria-label="New group name"
          placeholder="New group…"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); commit(); }
            if (e.key === 'Escape') { setDraft(''); setAdding(false); }
          }}
        />
        <Button type="button" aria-label="Add group" title="Add group" onClick={commit}>＋</Button>
      </div>
    );
  }

  return (
    <Select
      aria-label={ariaLabel}
      value={value ?? ''}
      onChange={(e) => {
        if (e.target.value === ADD_SENTINEL) { setAdding(true); return; }
        onChange(e.target.value);
      }}
    >
      <option value="">— Group —</option>
      {options.map((g) => (
        <option key={g} value={g}>{g}</option>
      ))}
      <option value={ADD_SENTINEL} style={{ fontStyle: 'italic' }}>＋ Add group…</option>
    </Select>
  );
};

export default GroupSelect;
